const ca = {
  brand: "EcoGlow Detailing",
  nav: {
    home: "Inici",
    services: "Serveis",
    packs: "Packs",
    works: "Treballs",
    center: "Centre",
    zones: "Zones",
    about: "Nosaltres",
    blog: "Blog",
    contact: "Contacte",
    whatsapp: "WhatsApp",
    quote: "Demanar pressupost",
  },
  hero: {
    kicker: "Estudi de detailing · Els Muntells, Tarragona",
    h1a: "Detailing professional als Muntells,",
    h1b: "Amposta i voltants.",
    sub: "Transformem, cuidem i protegim el teu vehicle amb tractaments professionals de detailing.",
    cta1: "Demanar pressupost",
    cta2: "Descobrir serveis",
    scroll: "Fes scroll",
  },
  intro: {
    kicker: "L'estàndard EcoGlow",
    title: "Més que una neteja, cura professional per al teu vehicle.",
    text: "A EcoGlow Detailing ens especialitzem en la cura estètica de l'automòbil. Treballem cada vehicle amb atenció al detall, productes professionals i tractaments adaptats a les seves necessitats.",
    m1t: "Interior a domicili",
    m1d: "Neteges interiors on sigui el teu cotxe, a tota la zona.",
    m2t: "Centre als Muntells",
    m2d: "El nostre estudi equipat per a tractaments complets.",
    m3t: "Recollida i lliurament",
    m3d: "Recollim el teu vehicle i te'l tornem acabat.",
  },
  home: {
    servicesKicker: "Serveis",
    servicesTitle: "Tractaments de detailing professional",
    servicesSub: "Cada servei té el seu procés, els seus productes i el seu acabat. Tria el que necessita el teu cotxe.",
    viewService: "Veure servei",
    packsKicker: "Packs EcoGlow",
    packsTitle: "Packs pensats per al teu cotxe",
    packsCta: "Consultar packs i preus",
    recommended: "Recomanat",
    worksKicker: "Treballs realitzats",
    worksTitle: "El resultat parla per si mateix",
    worksPlaceholder: "Estem preparant la nostra galeria de treballs reals: abans i després, procés i resultat. Molt aviat podràs veure aquí el que fem al centre.",
    worksNote: "Fotografia de referència: els treballs reals es publicaran aquí properament.",
    worksCta: "Veure tots els treballs",
    whyKicker: "Per què EcoGlow",
    whyTitle: "Per què triar EcoGlow Detailing",
    why: [
      { t: "Atenció personalitzada", d: "Cada cotxe s'avalua abans de proposar-te res. Sense plantilles." },
      { t: "Productes professionals", d: "Química i consumibles de gamma professional, no de supermercat." },
      { t: "Acabats cuidats", d: "El detall és el nostre ofici: juntes, gomes, reixetes, tapisseria." },
      { t: "Tractaments especialitzats", d: "Polit, correcció de pintura, ceràmica i Fusso Coat." },
      { t: "Centre físic", d: "Un estudi real als Muntells on deixem el teu cotxe a punt." },
      { t: "Recollida i lliurament", d: "No et moguis: recollim i tornem el teu vehicle." },
      { t: "Interior a domicili", d: "La neteja interior també a casa teva o a la feina." },
    ],
    zonesKicker: "Zones de servei",
    zonesTitle: "Treballem a tota la zona",
    zonesSub: "Centre als Muntells i servei mòbil de neteja interior a les localitats properes.",
    reviewsKicker: "Opinions",
    reviewsTitle: "Què diuen els nostres clients",
    reviewsEmpty: "Només mostrem opinions reals dels nostres clients publicades a Google: res d'inventat. Si ja has passat per EcoGlow, la teva ressenya ens ajuda molt.",
    reviewsGmb: "Deixar una ressenya a Google",
    faqKicker: "Preguntes freqüents",
    faqTitle: "Resolem els teus dubtes",
    contactKicker: "Contacte",
    contactTitle: "Demana el teu pressupost sense compromís",
    contactSub: "Explica'ns què necessita el teu cotxe i et responem per WhatsApp.",
  },
  faqs: [
    { q: "On sou?", a: "El nostre centre és als Muntells (Tarragona). Per privacitat no publiquem l'adreça exacta: en reservar t'indiquem com arribar-hi. També treballem amb recollida i lliurament del vehicle." },
    { q: "Feu servei a domicili?", a: "Sí, però actualment el servei a domicili és exclusivament per a neteges interiors. Els tractaments de pintura, polit i protecció es fan al nostre centre dels Muntells." },
    { q: "Com funciona la recollida i lliurament?", a: "Recollim el teu vehicle a la zona (Amposta, Deltebre, Sant Jaume d'Enveja, la Ràpita, Tortosa i voltants), fem el tractament al centre i te'l tornem acabat. Consulta'ns disponibilitat." },
    { q: "Quant costa?", a: "Els preus depenen del servei i de la mida del vehicle (S, M o XL). Consulta la pàgina de packs i preus o demana'ns pressupost per WhatsApp sense compromís." },
    { q: "Què vol dir S, M i XL?", a: "És la categoria segons la mida del cotxe: S per a utilitaris i compactes, M per a berlines i SUV mitjans, XL per a SUV grans, 4x4 i furgonetes. Si tens dubtes, et confirmem la categoria del teu model." },
    { q: "Com reservo?", a: "La manera més ràpida és per WhatsApp al 691 622 449. Explica'ns el servei que vols, el model de cotxe i la teva localitat, i et proposem data." },
    { q: "Quant dura el tractament ceràmic o el Fusso Coat?", a: "El Fusso Coat anuncia una durada de fins a 12 mesos segons les condicions d'ús. En el cas del tractament ceràmic, la durada depèn del producte, de l'ús i del manteniment: t'ho expliquem en persona sense promeses inflades." },
  ],
  contact: {
    title: "Contacte",
    kicker: "Contacte",
    heading: "Parlem del teu cotxe",
    sub: "Omple el formulari i s'obrirà WhatsApp amb el teu missatge ja redactat. També ens pots trucar directament.",
    name: "Nom",
    phone: "Telèfon",
    model: "Marca i model",
    service: "Servei sol·licitat",
    size: "Mida del vehicle",
    locality: "Localitat",
    message: "Missatge",
    send: "Enviar per WhatsApp",
    call: "Trucar ara",
    wa: "Obrir WhatsApp",
    selectService: "Selecciona un servei",
    selectSize: "Selecciona la mida",
    sizeS: "S · Utilitari / compacte",
    sizeM: "M · Berlina / SUV mitjà",
    sizeXL: "XL · SUV gran / 4x4 / furgoneta",
    notSure: "No n'estic segur",
    infoCenter: "Centre físic als Muntells (l'adreça exacta es facilita en reservar)",
    infoPickup: "Recollida i lliurament de vehicles a la zona",
    infoHome: "Neteja interior a domicili",
    sent: "S'obrirà WhatsApp amb el teu missatge llest per enviar.",
  },
  servicesPage: {
    kicker: "Serveis",
    title: "Serveis de detailing professional",
    sub: "Cura interior, exterior, correcció de pintura i protecció. Cada tractament amb el seu procés i el seu acabat, al nostre centre dels Muntells o, en el cas de la neteja interior, també a domicili.",
    includes: "Inclou",
    cta: "Demanar pressupost",
  },
  servicePage: {
    includes: "Què inclou",
    process: "El procés",
    where: "On es realitza",
    faq: "Preguntes freqüents",
    ctaTitle: "En parlem?",
    ctaText: "Explica'ns el teu model i l'estat del cotxe i et donem pressupost tancat per WhatsApp.",
    related: "Serveis relacionats",
    back: "Tots els serveis",
    priceNote: "Preu segons la mida del vehicle. Consulta packs i preus.",
  },
  packs: {
    kicker: "Packs i preus",
    title: "Packs i preus EcoGlow",
    sub: "Preus clars segons la mida del teu vehicle. S: utilitaris i compactes · M: berlines i SUV mitjans · XL: SUV grans, 4x4 i furgonetes. Si no saps la categoria del teu cotxe, te la confirmem per WhatsApp.",
    cleaning: "Neteja",
    correction: "Correcció",
    protection: "Protecció",
    packsTitle: "Packs",
    extras: "Extres",
    packContents: "Composició del pack",
    cta: "Demanar pressupost",
    note: "Fusso Coat i tractament ceràmic es pressuposten com a complement (+) sobre el servei base. Tots els preus amb IVA inclòs segons tarifa vigent.",
    packNames: { esencial: "Rejoveniment Essencial", escudo: "Escut Total", maxima: "Màxima Protecció" },
    packItems: {
      esencial: ["Neteja interior profunda", "Neteja exterior completa"],
      escudo: ["Neteja interior profunda", "Neteja exterior completa", "Descontaminació", "Polit One-Step", "Protecció Fusso Coat"],
      maxima: ["Neteja interior profunda", "Neteja exterior completa", "Descontaminació", "Polit de dos passos", "Tractament ceràmic professional", "Tractament de vidres de cortesia"],
    },
    sizeNote: "S, M i XL corresponen a la mida del vehicle. Consulta'ns la categoria del teu cotxe.",
  },
  worksPage: {
    kicker: "Treballs realitzats",
    title: "Treballs realitzats",
    sub: "Abans i després, procés i resultat. Només treballs reals fets a EcoGlow.",
    empty: "Estem documentant els nostres primers treballs amb fotografies reals d'abans i després. Molt aviat veuràs aquí els projectes del centre. Mentrestant, demana'ns exemples per WhatsApp i te'ls ensenyem.",
    vehicle: "Vehicle",
    service: "Servei",
    process: "Procés",
    result: "Resultat",
  },
  center: {
    kicker: "El nostre centre",
    title: "El nostre centre als Muntells",
    sub: "Un espai pensat per treballar el teu cotxe amb la calma i la precisió que el detailing exigeix.",
    body1: "El cor d'EcoGlow Detailing és el nostre centre de treball als Muntells (Tarragona). És aquí on fem els tractaments més exigents: polit, correcció de pintura, Fusso Coat i tractament ceràmic.",
    body2: "Per privacitat no publiquem l'adreça postal exacta: en confirmar la reserva t'indiquem com arribar-hi i on deixar el vehicle.",
    f1t: "Il·luminació d'inspecció",
    f1d: "Llum específica per detectar defectes de pintura abans i després del polit.",
    f2t: "Productes professionals",
    f2d: "Química de detailing de gamma professional per a cada superfície.",
    f3t: "Feina sense presses",
    f3d: "Cada cotxe té el seu temps. No treballem en cadena.",
    pickup: "No pots venir? Recollim el teu vehicle i te'l tornem acabat.",
  },
  zones: {
    kicker: "Zones de servei",
    title: "Zones de servei",
    sub: "Centre físic als Muntells, recollida i lliurament a la comarca i neteja interior a domicili a les localitats properes.",
    centerZone: "Centre físic",
    centerDesc: "Tots els serveis: neteges, polit, correcció, Fusso Coat i ceràmica.",
    mobileZone: "Servei mòbil",
    mobileDesc: "Neteja interior a domicili. La resta de serveis es fan al centre o amb recollida i lliurament.",
    howTitle: "Com funciona",
    how1: "Reserva per WhatsApp indicant la teva localitat.",
    how2: "Per a neteja interior, anem al teu domicili. Per a la resta, recollim el cotxe o el portes al centre.",
    how3: "Et tornem el vehicle acabat, on et vingui millor.",
    note: "La teva localitat no hi apareix? Escriu-nos: valorem desplaçaments propers.",
  },
  about: {
    kicker: "Sobre EcoGlow",
    title: "Sobre EcoGlow Detailing",
    body1: "EcoGlow Detailing neix als Muntells, en ple Delta de l'Ebre, amb una idea clara: tractar cada cotxe com si fos el nostre. Ni rentats exprés ni solucions miraculoses: procés, producte professional i atenció al detall.",
    body2: "Vivim en una zona exigent per a la pintura: sol, salnitre, pols i sorra del Delta. Per això ens especialitzem no només a netejar, sinó a corregir i protegir, perquè el resultat durés.",
    body3: "Treballem de tres maneres: al nostre centre dels Muntells, amb recollida i lliurament del vehicle, i a domicili per a neteges interiors. Tu tries com et ve millor.",
    v1t: "Detall",
    v1d: "El detailing és precisament això: cuidar allò que ningú mira.",
    v2t: "Honestedat",
    v2d: "Et diem el que el teu cotxe necessita i el que no. Sense fum.",
    v3t: "Proximitat",
    v3d: "Un negoci local que respon per WhatsApp, com ha de ser.",
  },
  blog: {
    kicker: "Blog",
    title: "Blog de detailing",
    sub: "Guies i consells de cura de l'automòbil, escrits des de l'experiència del centre.",
    read: "Llegir article",
    min: "min de lectura",
    back: "Tornar al blog",
    related: "Serveis relacionats",
    more: "Més articles",
  },
  reviews: {
    basedOn: "Basat en 9 ressenyes de Google",
    readAll: "Veure totes les ressenyes a Google",
  },
  footer: {
    desc: "Detailing professional als Muntells, Tarragona. Neteja, correcció i protecció estètica de vehicles.",
    services: "Serveis",
    company: "Empresa",
    contact: "Contacte",
    zonesTitle: "Zones de servei",
    rights: "Tots els drets reservats.",
    madeIn: "Els Muntells · Delta de l'Ebre",
  },
  floating: { quote: "Pressupost" },
  seo: {
    home: { title: "Detailing professional als Muntells, Amposta i voltants | EcoGlow Detailing", desc: "Transformem, cuidem i protegim el teu vehicle. Neteja interior i exterior, polit, tractament ceràmic i Fusso Coat als Muntells, Tarragona." },
    services: { title: "Serveis de detailing professional | EcoGlow Detailing", desc: "Neteja interior i exterior, detailing integral, polit, correcció de pintura, ceràmica, Fusso Coat i restauració de fars als Muntells i voltants." },
    packs: { title: "Packs i preus de detailing | EcoGlow Detailing", desc: "Preus clars per mida de vehicle: neteges, polits, proteccions i packs complets de detailing als Muntells, Tarragona." },
    works: { title: "Treballs realitzats | EcoGlow Detailing", desc: "Galeria de treballs reals de detailing als Muntells: abans i després, procés i resultat." },
    center: { title: "El nostre centre de detailing als Muntells | EcoGlow Detailing", desc: "Coneix el centre d'EcoGlow Detailing als Muntells: il·luminació d'inspecció, productes professionals i feina sense presses." },
    zones: { title: "Zones de servei: Els Muntells, Amposta, Deltebre, Tortosa | EcoGlow Detailing", desc: "Servei de detailing als Muntells, Amposta, Deltebre, Sant Jaume d'Enveja, la Ràpita, Tortosa i localitats properes." },
    about: { title: "Sobre EcoGlow Detailing | Detailing professional al Delta de l'Ebre", desc: "Coneix EcoGlow Detailing: cura estètica professional de l'automòbil als Muntells, Tarragona." },
    contact: { title: "Contacte i pressupost | EcoGlow Detailing", desc: "Demana pressupost de detailing per WhatsApp. Centre als Muntells, recollida i lliurament, i neteja interior a domicili." },
    blog: { title: "Blog de detailing i cura del cotxe | EcoGlow Detailing", desc: "Guies de detailing, polit, ceràmica i cura de l'automòbil escrites per professionals als Muntells." },
  },
};

export default ca;
